/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name tablearrownav
 * @description Implements spreadsheet style key navigation behaviour in an HTML table.
 *   Behaviour is:
 *    - first click on cell or navigation into it via keypress = enter data, it appears
 *    - arrow keys after first click / key navigation = move to next cell
 *    - enter key = move down a cell in the same column (same as down arrow)
 *    - second click on cell after click / key navigation = move cursor within cell
 * @attr {String} tablearrownav An identifier used to find the next or previous input.
 * @attr {String} tablearrownav-width Defines how many columns are in the table, used
 *   to determine the up/down index adjustment. Set this to the number of columns that
 *   the inputs are spread over. Defaults to 1.
 */
angular.module('mercury.directives.tablearrownav', [])
.directive('tablearrownav', ["$parse", "$timeout", function($parse, $timeout) {
  return {
    restrict: 'A',
    scope: true,
    link: function postLink(scope, element, attrs) {

      var numColumns = parseInt(attrs.tablearrownavWidth) || 1;

      // Keep track of click status on an element, necessary to know what to
      // do when the arrow keys are pressed.
      element.on('click', function() {
        $timeout(function() {
          var $el = $(element);
          var alreadyFocussed = $el.attr('data-focussed') || false;

          if (alreadyFocussed) {
            $el.attr('data-cursoractive', true);
          } else {
            $el.attr('data-focussed', true);
          }

        });
      });

      // Reset click tracking data when a cell becomes inactive.
      element.on('blur', function() {
        $(element).removeAttr('data-focussed');
        $(element).removeAttr('data-cursoractive');
      });

      // Handle arrow key presses, determining where to shift the focus to.
      element.on('keydown', function(e) {
        $timeout(function() {

          if (
            // Ignore any key presses that aren't arrow navigation
            !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'].includes(e.key) ||
            // Ignore left right navigation if the user hasn't clicked into a
            // cell twice (like a spreadsheet) or we're in single column mode.
            (['ArrowLeft', 'ArrowRight'].includes(e.key) && (!!$(element).attr('data-cursoractive') || numColumns === 1))
          ) {
            return;
          }

          // Get all cells in the table and the index of the currently clicked element
          var tableElements;

          // If numColumns is greater than one this means the table has been marked up to
          // support multiple columns and navigation with the left / right key between them.
          // We need to work with the full set of elements to manage this. Conversely if a
          // table isn't marked up we need to ensure that we only find the inputs that match
          // the type we're currently on to constrain navigation to up and down in the current
          // row correctly.
          if (numColumns > 1) {
            tableElements = $(element).parent().closest('table').find('[tablearrownav]');
          } else {
            tableElements = $(element).parent().closest('table').find('[tablearrownav=' + attrs.tablearrownav + ']');
          }

          var index = tableElements.index($(element));

          // Alter index value based on navigation direction
          switch (e.key) {
            case 'ArrowUp':
              index += -numColumns;
            break;
            case 'Enter':
            case 'ArrowDown':
              index += numColumns;
            break;
            case 'ArrowLeft':
              index += -1;
            break;
            case 'ArrowRight':
              index += 1;
            break;
          }

          // Focus the element at the new index.
          if (tableElements[index] && !tableElements[index].disabled) {
            tableElements[index].click();
          } else {
            // If there isn't a table element at the index (can happen when in
            // the last row and pressing enter for example) we instead trigger
            // a blur event on the currently active element to remove focus and
            // then immediately focus it again. This ensures any blur event
            // handlers that might be attached to the table inputs are run the
            // same way as they would be if we'd moved to the next row.
            element.trigger('blur');
            element.trigger('focus');
          }

        });
      });

    }
  };
}]);
